module.exports = __webpack_public_path__ + "static/media/yvesDerains.5e710c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/yvesDerains.jpg
// module id = 1598
// module chunks = 1